<template>
  <div>
    <Video></Video>
    <Info></Info>
    <Map></Map>
  </div>
</template>

<script>
import Video from './Video'
import Info from './Info'
import Map from './Map'

export default {
  components: {
    Info,
    Video,
    Map
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main.vue